module.exports = __webpack_public_path__ + "img/1_1-piazza-2-statua.15c316b1.png";